import React, { Component } from "react";
import "./InfoHeader.css";
import { Typography } from "@material-ui/core";

export default class InfoHeader extends Component {

    render() {
        const { children } = this.props;
        return (
            <div className="InfoHeader">
                <Typography
                    color="primary"
                    variant="h6"
                    style={{
                        fontWeight: 400
                    }}
                >
                    {children}
                </Typography>
            </div>
        );
    }

}